import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "pop-slippage",
  props: {
    show: Boolean
  },
  computed: {
    ...walletVuex.mapState(["isMobile"]),
    ...userVuex.mapState(["web3Data", "userInfo"])
  },
  data() {
    return {
      amount: 0,
      isBtnLoading: null,
      err: null,
      selectSwitch: null
    };
  },
  watch: {
    show(bool) {
      if (!bool) {
        this.amount = 0;
        this.isBtnLoading = null;
      }
    }
  },
  methods: {
    onClose() {
      this.$emit("update:show", false);
    },
    onInput() {
      this.isBtnLoading = false;
      const regex = /^(?!0\d)\d*(\.\d{0,4})?$/;
      if (!regex.test(this.amount)) {
        this.amount = this.amount.slice(0, -1);
      }
    },
    onSwitch(item) {
      const myStake = this.fmt_floatDec(this.web3Data.myStake);
      this.amount = this.fmt_dp(myStake * item, 4);
    },
    async onApply() {
      if (!this.amount && this.amount <= 0) {
        this.err = "Please enter amount";
        return;
      }
      const myStake = this.fmt_floatDec(this.web3Data.myStake);
      if (this.amount > myStake) {
        this.err = "Insufficient $MARSP";
        return;
      }
      this.err = "";
      if (this.isBtnLoading) return;
      this.isBtnLoading = true;
      const that = this.$parent;
      try {
        const amt = String(this.fmt_floatDec(this.amount, "wei"));
        const isApprove = await that.checkApprove(amt);
        console.log("isApprove", isApprove, amt);
        if (!isApprove) {
          const tx = await that.marspApprove(amt);
          console.log("tx======", tx);
          this.isBtnLoading = false;
          this.onApply();
        } else {
          const ref = this.userInfo.referral;
          console.log("amtamtamtamt", amt, ref);
          const tx = await this.web3Wallet.contract("marspump", "marsPumpAddr").send("unstake", [amt, ref]);
          console.log(tx.transactionHash);
          this.$emit("update:show", false);
          this.$toasted.success("UnStake success");
          this.isBtnLoading = false;
          await this.web3Wallet.web3WindQueryFn();
        }
      } catch (err) {
        console.log("errr", err);
        this.isBtnLoading = false;
      }
    }
  }
};